import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import IndexMain from './Index_main.js';
import Feed from './Feed.js';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"  element={<IndexMain></IndexMain>} />
        <Route path="/feed/*" element={<Feed></Feed>} />
      
      </Routes>
    </Router>
  );
}

export default App;
